// src/context/DateFormatContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const DateFormatContext = createContext();

const getInitialFormat = () => {
  return localStorage.getItem("dateFormat") || "MM/DD/YY";
};

export const DateFormatProvider = ({ children }) => {
  const [format, setFormat] = useState(getInitialFormat());

  useEffect(() => {
    localStorage.setItem("dateFormat", format);
  }, [format]);

  return (
    <DateFormatContext.Provider value={{ format, setFormat }}>
      {children}
    </DateFormatContext.Provider>
  );
};

export const useDateFormat = () => useContext(DateFormatContext);